import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiShield, FiTarget, FiZap } = FiIcons;

const QuizCTA = () => {
  const benefits = [
    {
      icon: FiTarget,
      text: "Identify your specific sleep challenges"
    },
    {
      icon: FiZap,
      text: "Get personalized recommendations"
    },
    {
      icon: FiClock,
      text: "Takes only 3 minutes"
    },
    {
      icon: FiShield,
      text: "100% private and confidential"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-accent-magenta via-accent-purple to-accent-lavender">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-white"
        >
          <h2 className="text-3xl lg:text-5xl font-playfair font-bold mb-8">
            Ready to Discover Your Sleep Pattern?
          </h2>
          
          <p className="text-xl mb-12 opacity-90">
            Take our free assessment to understand what's really keeping you awake
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white/20 backdrop-blur-sm rounded-xl p-6"
              >
                <SafeIcon icon={benefit.icon} className="w-8 h-8 mx-auto mb-4 text-white" />
                <p className="text-white font-raleway font-medium">{benefit.text}</p>
              </motion.div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.a
              href="https://www.wethebillions.com/quiz"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-accent-magenta px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-200 shadow-xl"
            >
              Take the Free Quiz
            </motion.a>
            
            <motion.button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-accent-magenta transition-all duration-200"
            >
              Book Free Consultation
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default QuizCTA;